export enum OnboardingEvents {
  AUTO_REDIRECT_USER = 'auto_redirect_user',
  EXIT_ONBOARDING_FLOW = 'exit_onboarding_flow',
  SKIP_ONBOARDING_STEP = 'skip_onboarding_step',
  COMPLETE_ONBOARDING_STEP = 'complete_onboarding_step',
  SELECT_ACCOUNT_TYPE = 'select_account_type',
  TYPING = 'typing',
  QUEST = 'quest',
  QUEST_CARD_CLICK = 'quest_card_click',
  QUEST_COMPLETE = 'quest_complete',
  CLOSE_CUSTOMIZE_EXPERIENCE_MODAL = 'close_customize_experience_modal',
  OPEN_CUSTOMIZE_EXPERIENCE_MODAL = 'open_customize_experience_modal',
  CHECKBOX = 'checkbox',
  COMPLETE_ONBOARDING_PROCESS = 'complete_onboarding_process',
  BUTTONCLICK = 'button_click',
  VCC_FROM_MENU = 'select_vcc_from_menu_system',
  VCC_FROM_SEARCH = 'select_vcc_from_search_field',
  HOM_METHODS_OPEN = 'hom_methods_open',
  HOM_METHODS_CLOSE = 'hom_methods_close',
  PRODUCT_VIDEO_WATCHED = 'product_video_watched',
}
